import { Component } from '@angular/core';
import { SERVICE_SETTINGS_EPICRISIS_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';

@Component({
    selector: 'app-service-settings-epicrisis',
    templateUrl: './service-settings-epicrisis.component.html',
    styleUrl: './service-settings-epicrisis.component.scss',
    imports: [
        ServiceSettingsCommonComponent,
    ],
})
export class ServiceSettingsEpicrisisComponent {
    protected readonly SERVICE_SETTINGS_EPICRISIS_TYPE_KEY = SERVICE_SETTINGS_EPICRISIS_TYPE_KEY;
}
